import cookieCommons from 'common/cookieCommons';
import { memo } from 'react';
import { HiOutlineUserAdd } from 'react-icons/hi';
import useFollow from '../../../../hooks/useFollow';
import { INotRequestFollowYet } from '../../../../interfaces/components/profileElement.interface';
import { RoleViewEnum } from '../../../../interfaces/profile.interface';

const NotRequestFollowYet: React.FC<INotRequestFollowYet> = ({
  roleView,
  setLoginModal,
  uid,
  refectAfterChangeInformation,
}) => {
  const { requestFollow } = useFollow();

  return (
    <>
      {roleView === RoleViewEnum.Guest && (
        <button
          className="bg-primary__gradient my-10 flex w-full justify-center rounded-xl p-2 text-[14px] text-white sm:my-2 sm:w-fit sm:px-4"
          onClick={() => {
            if (cookieCommons.getAccessToken()) {
              requestFollow({
                userId: uid,

                callback: async () => {
                  await refectAfterChangeInformation();
                },
              });
            } else {
              setLoginModal(true);
            }
          }}
        >
          <span className="my-auto">
            <HiOutlineUserAdd className="text-[18px]" />
          </span>
          <span className="ml-2 text-[16px]">Theo dõi</span>
        </button>
      )}
    </>
  );
};

export default memo(NotRequestFollowYet);
